module.exports = __webpack_public_path__ + "static/media/about_me.b85b9415.jpg";